import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tipo',
  templateUrl: './tipo.component.html',
  styleUrls: ['./tipo.component.scss']
})
export class TipoComponent implements OnInit {

  router;
  display: string;

  constructor(router: Router) {
    this.router = router;
  }

  ngOnInit() {
    switch (this.router.url) {
      case '/servicios/humedad':
        this.display = 'humedad';
        break;
      case '/servicios/temperatura':
        this.display = 'temperatura';
        break;
    }
  }

}
